module.exports = __webpack_public_path__ + "static/media/vicePresident.c47b2ddf.jpg";